export default "__VITE_PUBLIC_ASSET__fa1eb2e8__"